import { render, staticRenderFns } from "./sendProcedureModal.vue?vue&type=template&id=1884311e&"
import script from "./sendProcedureModal.vue?vue&type=script&lang=js&"
export * from "./sendProcedureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports